const routes = [
  // Landing Page
  {
    url: '/landing-page',
    file (resolve) { require(['./components/LandingPage'], resolve) }
  },
  // Responsive Management
  {
    url: '/dashboard',
    file (resolve) { require(['./components/user-dashboard/Index.vue'], resolve) }
  },
  {
    url: '/Capacity-Booking-and-RPT/responsive-management/nominate-responsive-products',
    file (resolve) { require(['./components/responsivemanagment/GisWorkflow'], resolve) }
  },
  {
    url: '/SOURCING-WF/RESPONSIVE-MANAGEMENT/GIS-WORKFLOW-E2E',
    file (resolve) { require(['./components/responsivemanagment/GisWorkflow'], resolve) }
  },
  {
    url: '/SOURCING-WF/RESPONSIVE-MANAGEMENT/GIS-WORKFLOW-QA',
    file (resolve) { require(['./components/responsivemanagment_qa/GisWorkflow'], resolve) }
  },
  {
    url: '/SOURCING-WF/RESPONSIVE-MANAGEMENT/GIS-WORKFLOW-STATIC',
    file (resolve) { require(['./components/responsivemanagment_static/GisWorkflow'], resolve) }
  },
  {
    url: '/SOURCING-WF/RESPONSIVE-MANAGEMENT/VENDOR-REPORT',
    file (resolve) { require(['./components/vendoraccessreport/VendorReport'], resolve) }
  },
  {
    url: '/SOURCING-WF/RESPONSIVE-MANAGEMENT/SUPERS-REPORT',
    file (resolve) { require(['./components/vendoraccessreport/SupersReport'], resolve) }
  },
  // {
  //   url: '/SOURCING-WF/RESPONSIVE-MANAGEMENT/EXPORT-DATA',
  //   file (resolve) { require(['./components/exportdata/exportMain'], resolve) }
  // },
  // {
  //   url: '/SOURCING-WF/RESPONSIVE-MANAGEMENT/EXPORT-DATA-VIEW',
  //   file (resolve) { require(['./components/exportdata/PoListView'], resolve) }
  // },
  {
    url: '/SOURCING-WF/RESPONSIVE-MANAGEMENT/EXPORT-MULTI-DATA',
    file (resolve) { require(['./components/rpt-multiple-brand-report/exportMain'], resolve) }
  },
  {
    url: '/SOURCING-WF/RESPONSIVE-MANAGEMENT/EXPORT-MULTI-DATA-VIEW',
    file (resolve) { require(['./components/rpt-multiple-brand-report/PoListView'], resolve) }
  },
  // {
  //   url: '/SOURCING-WF/RESPONSIVE-MANAGEMENT/EXPORT-DATA-QA',
  //   file (resolve) { require(['./components/exportdata_qa/exportMain'], resolve) }
  // }
  // {
  //   url: '/SOURCING-WF/RESPONSIVE-MANAGEMENT/EXPORT-DATA-VIEW-QA',
  //   file (resolve) { require(['./components/exportdata_qa/PoListView'], resolve) }
  // },
  // Booking
  {
    url: '/SOURCING-WF/BOOKING-MGMT/booking',
    file (resolve) { require(['./components/LandingBookingPage'], resolve) }
  },
  {
    url: '/Capacity-Booking-and-RPT/booking-management/Review-Booking',
    file (resolve) { require(['./components/LandingBookingPage'], resolve) }
  },
  {
    url: '/SOURCING-WF/BOOKING-MGMT/Vd',
    file (resolve) { require(['./components/LandingBookingPage'], resolve) }
  },
  // {
  //   url: '/SOURCING-WF/BOOKING-MGMT/importfile',
  //   file (resolve) { require(['./components/booking/importfile'], resolve) }
  // },
  {
    url: '/SOURCING-WF/BOOKING-MGMT/faq-gis',
    file (resolve) { require(['./components/LandingBookingPage'], resolve) }
  },
  {
    url: '/Capacity-Booking-and-RPT/booking-management/faq-vendor',
    file (resolve) { require(['./components/LandingBookingPage'], resolve) }
  },
  {
    url: '/Capacity-Booking-and-RPT/booking-management/faq-mst',
    file (resolve) { require(['./components/LandingBookingPage'], resolve) }
  },
  {
    url: '/SOURCING-WF/BOOKING-MGMT/generatereport',
    file (resolve) { require(['./components/LandingBookingPage'], resolve) }
  },
  {
    url: '/SOURCING-WF/BOOKING-MGMT/BTM',
    file (resolve) { require(['./components/LandingBookingPage'], resolve) }
  },
  {
    url: '/SOURCING-WF/BOOKING-MGMT/mst-task-assign',
    file (resolve) { require(['./components/LandingBookingPage'], resolve) }
  },
  {
    url: '/SOURCING-WF/BOOKING-MGMT/mst-task-update',
    file (resolve) { require(['./components/LandingBookingPage'], resolve) }
  },
  // Change Management
  {
    url: '/SOURCING-WF/CHANGE-MGMT/Create-New',
    file (resolve) { require(['./components/changemanagement/CreateRequest'], resolve) }
  },
  {
    url: '/SOURCING-WF/CHANGE-MGMT/Create-New-LDL',
    file (resolve) { require(['./components/changemanagement/CreateRequestForLDL'], resolve) }
  },
  {
    url: '/SOURCING-WF/CHANGE-MGMT/Receipt-Changes',
    file (resolve) { require(['./components/changemanagement/SearchEdit'], resolve) }
  },
  {
    url: '/SOURCING-WF/CHANGE-MGMT/LDL-Changes',
    file (resolve) { require(['./components/changemanagement/SearchEditForLDL'], resolve) }
  },
  {
    url: '/SOURCING-WF/CHANGE-MGMT/General-Settings',
    file (resolve) { require(['./components/changemanagement/EmailNotificationSettings'], resolve) }
  },
  {
    url: '/SOURCING-WF/CHANGE-MGMT/Email-Subscription',
    file (resolve) { require(['./components/changemanagement/EmailUserNotificationSettings'], resolve) }
  },
  {
    url: '/SOURCING-WF/CHANGE-MGMT/FAQ-changemgmt',
    file (resolve) { require(['./components/changemanagement/FAQ-changemgmt'], resolve) }
  },
  {
    url: '/SOURCING-WF/CHANGE-MGMT/Create-New-Step',
    file (resolve) { require(['./components/changemanagement/NewChase'], resolve) }
  },
  {
    url: '/SOURCING-WF/CHANGE-MGMT/Search-Other',
    file (resolve) { require(['./components/changemanagement/SearchOther'], resolve) }
  },
  {
    url: '/SOURCING-WF/CHANGE-MGMT/Create-New-PO',
    file (resolve) { require(['./components/changemanagement/CreateRequestForPO'], resolve) }
  },
  // Production Management
  {
    url: '/SOURCING-WF/PROD-MGMT/Template-Config',
    file (resolve) { require(['./components/productionmanagement/TemplateManagement'], resolve) }
  },
  {
    url: '/SOURCING-WF/PROD-MGMT/Milestone-Config',
    file (resolve) { require(['./components/productionmanagement/MilestoneManagement'], resolve) }
  },
  {
    url: '/SOURCING-WF/PROD-MGMT/Production-Tracking',
    file (resolve) { require(['./components/productionmanagement/WipSearch'], resolve) }
  },
  {
    url: '/SOURCING-WF/PROD-MGMT/Production-Reporting',
    file (resolve) { require(['./components/productionmanagement/Reporting'], resolve) }
  },
  // MST Vendor Connect
  {
    url: '/SOURCING-WF/SERVICE-REQUEST/CREATE',
    file (resolve) { require(['./components/sourcing_workflow/service_request/Create'], resolve) }
  },
  {
    url: '/SOURCING-WF/SERVICE-REQUEST/edit/:id',
    file (resolve) { require(['./components/sourcing_workflow/service_request/Edit'], resolve) }
  },
  {
    url: '/SOURCING-WF/SERVICE-REQUEST/MST-INTERFACE',
    file (resolve) { require(['./components/sourcing_workflow/service_request/Search'], resolve) }
  },
  // Sample Management.
  ...require('./components/samplemanagement/routes.js'),
  // Commitment Management
  ...require('./components/commitmentmanagement/routes.js'),
  // Capacity Management
  {
    url: '/SOURCING-WF/Sample-Management/Review-Ad-Sample-Request',
    file (resolve) { require(['./components/samplemanagement/ReviewAdSampleRequests'], resolve) }
  },
  {
    url: '/SOURCING-WF/Sample-Management/Initiate-Ad-Sample-Request',
    file (resolve) { require(['./components/samplemanagement/InitiateAdSampleRequests'], resolve) }
  },
  {
    url: '/SOURCING-WF/Sample-Management/Ad-Sample-Matrix-Rules',
    file (resolve) { require(['./components/samplemanagement/AdSampleMatrixRules'], resolve) }
  },
  {
    url: '/SOURCING-WF/Sample-Management/Manual-Shipment',
    file (resolve) { require(['./components/samplemanagement/ManualShipment'], resolve) }
  },
  {
    url: '/SOURCING-WF/Sample-Management/Generate-Summary-Reports',
    file (resolve) { require(['./components/samplemanagement/GenerateSummaryReports'], resolve) }
  },
  {
    url: '/SOURCING-WF/Sample-Management/Print-QR-Code',
    file (resolve) { require(['./components/samplemanagement/PrintQRCode'], resolve) }
  },
  {
    url: '/SOURCING-WF/Sample-Management/Upload-Photos',
    file (resolve) { require(['./components/samplemanagement/UploadPhotos'], resolve) }
  },
  {
    url: '/SOURCING-WF/Sample-Management/Receive-Shipment',
    file (resolve) { require(['./components/samplemanagement/ReceiveShipment'], resolve) }
  },
  {
    url: '/SAMPLE-MGMT/AD/Init',
    file (resolve) { require(['./components/samplemanagement/InitiateAdSampleRequests.vue'], resolve) }
  },
  {
    url: '/SAMPLE-MGMT/AD/View-sample-request',
    file (resolve) { require(['./components/samplemanagement/ReviewAdSampleRequests.vue'], resolve) }
  },
  {
    url: '/SAMPLE-MGMT/AD/Mass-update',
    file (resolve) { require(['./components/samplemanagement/ReviewAdSampleRequests.vue'], resolve) }
  },
  {
    url: '/SAMPLE-MGMT/AD/Matrix-update',
    file (resolve) { require(['./components/samplemanagement/AdSampleMatrixRules.vue'], resolve) }
  },
  {
    url: '/SAMPLE-MGMT/AD/Report-download',
    file (resolve) { require(['./components/samplemanagement/ReviewAdSampleRequests.vue'], resolve) }
  },
  {
    url: '/SAMPLE-MGMT/Shipment/Create-AD-shipment',
    file (resolve) { require(['./components/samplemanagement/ManualShipment.vue'], resolve) }
  },
  {
    url: '/SAMPLE-MGMT/Shipment/Edit-AD-shipment',
    file (resolve) { require(['./components/samplemanagement/ManualShipment.vue'], resolve) }
  },

  // {
  // url: '/SAMPLE-MGMT/Shipment/Configure-courier',
  // file (resolve) { require(['./components/samplemanagement/SmsConfiguration.vue'], resolve) }
  // },
  // {
  // url: '/SAMPLE-MGMT/Shipment/Browse-interface',
  // file (resolve) { require(['./components/samplemanagement/SmsConfiguration.vue'], resolve) }
  // },
  {
    url: '/SAMPLE-MGMT/Shipment/Print-QR-code',
    file (resolve) { require(['./components/samplemanagement/ReviewAdSampleRequests.vue'], resolve) }
  },
  {
    url: '/SAMPLE-MGMT/Shipment/Print-packing-list',
    file (resolve) { require(['./components/samplemanagement/ReviewAdSampleRequests.vue'], resolve) }
  },
  {
    url: '/SAMPLE-MGMT/Receive/AD',
    file (resolve) { require(['./components/samplemanagement/ReceiveShipment.vue'], resolve) }
  },
  {
    url: '/SAMPLE-MGMT/Receive/View-Receiving-history',
    file (resolve) { require(['./components/samplemanagement/ReceiveShipment.vue'], resolve) }
  },
  {
    url: '/SAMPLE-MGMT/Receive/Brand-drop',
    file (resolve) { require(['./components/samplemanagement/ReviewAdSampleRequests.vue'], resolve) }
  },
  {
    url: '/SAMPLE-MGMT/Receive/Vendor-reject',
    file (resolve) { require(['./components/samplemanagement/ReviewAdSampleRequests.vue'], resolve) }
  },
  {
    url: '/SAMPLE-MGMT/Receive/Mass-update',
    file (resolve) { require(['./components/samplemanagement/ReviewAdSampleRequests.vue'], resolve) }
  },
  {
    url: '/SAMPLE-MGMT/Receive/Upload-photo',
    file (resolve) { require(['./components/samplemanagement/ReviewAdSampleRequests.vue'], resolve) }
  },
  {
    url: '/SAMPLE-MGMT/Receive/Re-order',
    file (resolve) { require(['./components/samplemanagement/ReviewAdSampleRequests.vue'], resolve) }
  },
  {
    url: '/SAMPLE-MGMT/Receive/Comment',
    file (resolve) { require(['./components/samplemanagement/ReviewAdSampleRequests.vue'], resolve) }
  },
  // {
  // url: '/SAMPLE-MGMT/Receive/Purpose-config',
  // file (resolve) { require(['./components/samplemanagement/SmsConfiguration.vue'], resolve) }
  // },
  // {
  // url: '/SAMPLE-MGMT/Receive/Brand-season-import-config',
  // file (resolve) { require(['./components/samplemanagement/SmsConfiguration.vue'], resolve) }
  // },
  // {
  // url: '/SAMPLE-MGMT/Receive/Sample-type-config',
  // file (resolve) { require(['./components/samplemanagement/SmsConfiguration.vue'], resolve) }
  // },

  // {
  // url: '/SAMPLE-MGMT/Admin/Maintain-manual-category',
  // file (resolve) { require(['./components/samplemanagement/SmsConfiguration.vue'], resolve) }
  // },

  // Capacity Management
  {
    url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-CREATE',
    file (resolve) { require(['./components/capacitymanagement/cptCreate'], resolve) }
  },
  {
    url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-ACKNOWLEDGE',
    file (resolve) { require(['./components/capacitymanagement/cptAcknowledge'], resolve) }
  },
  {
    url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-ACKNOWLEDGE-VIEW',
    file (resolve) { require(['./components/capacitymanagement/cptAcknowledgeView'], resolve) }
  },
  {
    url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-INPUT',
    file (resolve) { require(['./components/capacitymanagement/cptInput'], resolve) }
  },
  {
    url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-INPUT-VIEW',
    file (resolve) { require(['./components/capacitymanagement/cptInputView'], resolve) }
  },
  {
    url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-LIST',
    file (resolve) { require(['./components/capacitymanagement/cptList'], resolve) }
  },
  {
    url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-LIST-VIEW',
    file (resolve) { require(['./components/capacitymanagement/cptListView'], resolve) }
  },
  {
    url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-REPLACE',
    file (resolve) { require(['./components/capacitymanagement/replacePage'], resolve) }
  },
  {
    url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-ACKNOWLEDGE-OVERALL-VIEW',
    file (resolve) { require(['./components/capacitymanagement/cptAcknowledgeOverAllView'], resolve) }
  },
  {
    url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-LIST-OVERALL-VIEW',
    file (resolve) { require(['./components/capacitymanagement/cptListOverAllView'], resolve) }
  },
  {
    url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-INPUT-OVERALL-VIEW',
    file (resolve) { require(['./components/capacitymanagement/cptInputOverAllView'], resolve) }
  },
  {
    url: '/SOURCING-WF/CAPACITY-MANAGEMENT/CPT-REPLACE-OVERALL',
    file (resolve) { require(['./components/capacitymanagement/replaceOverallPage'], resolve) }
  },
  // VPS Extension
  {
    url: '/MASTER-DATA/VPS-EXTENSION/MILL-VENDOR-MASTER',
    file (resolve) { require(['./components/vps-extension/mill-vendor-master/VendorMaster'], resolve) }
  },
  {
    url: '/vps-extension/mill-vendor-master/view-profile/:id',
    file (resolve) { require(['./components/vps-extension/mill-vendor-master/view-profile/ViewProfile'], resolve) }
  },
  {
    url: '/vps-extension/mill-vendor-master/attribution/:id',
    file (resolve) { require(['./components/vps-extension/mill-vendor-master/attribution/Attribution'], resolve) }
  },
  {
    url: '/vps-extension/mill-vendor-master/relationship/:id',
    file (resolve) { require(['./components/vps-extension/mill-vendor-master/relationship/Relationship'], resolve) }
  },
  {
    url: '/MASTER-DATA/VPS-EXTENSION/MILL-FACILITY-PROFILE',
    file (resolve) { require(['./components/vps-extension/mill-facility-profile/List'], resolve) }
  },
  {
    url: '/vps-extension/mill-facility-profile/view-profile/:id',
    file (resolve) { require(['./components/vps-extension/mill-facility-profile/Detail'], resolve) }
  },
  {
    url: '/MASTER-DATA/VPS-EXTENSION/MILL-FACILITY-MASTER',
    file (resolve) { require(['./components/vps-extension/mill-facility-master/VendorMaster'], resolve) }
  },
  {
    url: '/vps-extension/mill-facility-master/attribution/:id',
    file (resolve) { require(['./components/vps-extension/mill-facility-master/attribution/Attribution'], resolve) }
  },
  {
    url: '/vps-extension/mill-facility-master/relationship/:id',
    file (resolve) { require(['./components/vps-extension/mill-facility-master/relationship/Relationship'], resolve) }
  },
  {
    url: '/MASTER-DATA/VPS-EXTENSION/MANUFACTURING-VENDOR-MASTER',
    file (resolve) { require(['./components/vps-extension/manufacturing-vendor-master/VendorMaster'], resolve) }
  },
  {
    url: '/vps-extension/manufacturing-vendor-master/vendor-master-view',
    file (resolve) { require(['./components/vps-extension/manufacturing-vendor-master/VendorMasterView'], resolve) }
  },
  // Test Result Management
  {
    url: '/SOURCING-WF/TEST-RESULT-MANAGEMENT/TEST-REPORT',
    file (resolve) { require(['./components/LandingTrmPage'], resolve) }
  },
  {
    url: '/SOURCING-WF/TEST-RESULT-MANAGEMENT/DETAIL',
    file (resolve) { require(['./components/LandingTrmPage'], resolve) }
  },
  {
    url: '/SOURCING-WF/TEST-RESULT-MANAGEMENT/VIEW',
    file (resolve) { require(['./components/LandingTrmPage'], resolve) }
  },
  {
    url: '/SOURCING-WF/TEST-RESULT-MANAGEMENT/INTERNAL-TEST-REPORT',
    file (resolve) { require(['./components/LandingTrmPage'], resolve) }
  },
  {
    url: '/SOURCING-WF/TEST-RESULT-MANAGEMENT/INTERNALDETAIL',
    file (resolve) { require(['./components/LandingTrmPage'], resolve) }
  },
  {
    url: '/SOURCING-WF/TEST-RESULT-MANAGEMENT/INTERNALVIEW',
    file (resolve) { require(['./components/LandingTrmPage'], resolve) }
  },
  {
    url: '/SOURCING-WF/TEST-RESULT-MANAGEMENT/report-review',
    file (resolve) { require(['./components/testresultmanagement/ReportView'], resolve) }
  },
  {
    url: '/SOURCING-WF/TEST-RESULT-MANAGEMENT/ReportViewBYId',
    file (resolve) { require(['./components/testresultmanagement/ReportViewBYId'], resolve) }
  },
  {
    url: '/SOURCING-WF/TEST-RESULT-MANAGEMENT/REPORTVIEWDETAIL',
    file (resolve) { require(['./components/testresultmanagement/ReportViewDetail'], resolve) }
  },
  // QAS
  {
    url: '/SOURCING-WF/INSPECTION-MANAGEMENT/SEARCH-SHIPMENT',
    file (resolve) { require(['./components/qas/searchShipment'], resolve) }
  },
  {
    url: '/SOURCING-WF/INSPECTION-MANAGEMENT/SEARCH-AUDIT',
    file (resolve) { require(['./components/qas/searchAudit'], resolve) }
  },
  {
    url: '/SOURCING-WF/INSPECTION-MANAGEMENT/CREATE-AUDIT',
    file (resolve) { require(['./components/qas/createAudit'], resolve) }
  },
  {
    url: '/SOURCING-WF/INSPECTION-MANAGEMENT/EDIT-AUDIT',
    file (resolve) { require(['./components/qas/createAudit'], resolve) }
  },
  {
    url: '/SOURCING-WF/INSPECTION-MANAGEMENT/COPY-AUDIT',
    file (resolve) { require(['./components/qas/createAudit'], resolve) }
  },
  {
    url: '/SOURCING-WF/INSPECTION-MANAGEMENT/CREATE-CORRELATIONAUDIT',
    file (resolve) { require(['./components/qas/createAudit'], resolve) }
  },
  {
    url: '/SOURCING-WF/INSPECTION-MANAGEMENT/PASS-RATE',
    file (resolve) { require(['./components/qas/passRate'], resolve) }
  },
  {
    url: '/SOURCING-WF/INSPECTION-MANAGEMENT/PLM',
    file (resolve) { require(['./components/qas/PLM'], resolve) }
  },
  {
    url: '/SOURCING-WF/INSPECTION-MANAGEMENT/PLM-CHART',
    file (resolve) { require(['./components/qas/plmChart'], resolve) }
  },
  // Admin
  {
    url: '/SOURCING-WF/ADMIN/ADMIN',
    file (resolve) { require(['./components/smee-administration/administration'], resolve) }
  },
  {
    url: '/SOURCING-WF/ADMIN/BATCH-TRIGGER',
    file (resolve) { require(['./components/batchtriggermanagement/batchTriggerList'], resolve) }
  },
  {
    url: '/SOURCING-WF/ADMIN/USER-SUBSCRIPTION',
    file (resolve) { require(['./components/my-settings/user-subscription'], resolve) }
  },
  {
    url: '/my-settings/my-profile',
    file (resolve) { require(['./components/my-settings/user-profile/'], resolve) }
  },
  {
    url: '/my-settings/my-profile/edit',
    file (resolve) { require(['./components/my-settings/user-profile/modify'], resolve) }
  },
  // {
  //   url: '/SOURCING-WF/DEMO/DATATABLE3-DEMO',
  //   file (resolve) { require(['./components/demo/Datatable3'], resolve) }
  // }
  // My Settings, user subscription, push notification, my profile
  {
    url: '/my-settings/user-subscription',
    file (resolve) { require(['./components/my-settings/user-subscription'], resolve) }
  },
  {
    url: '/my-settings/push-notification',
    file (resolve) { require(['./components/my-settings/push-notification'], resolve) }
  }
].map(route => ({
  path: route.url,
  component: route.file
}))

export default routes



// WEBPACK FOOTER //
// ./src/routes.js